import React, { useEffect, useState, useRef } from "react";
import Helper from "../functions/Helper.js";
import { shoeAffiliateData } from "../functions/tracking.js";
import { HashLink as Link } from "react-router-hash-link";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";



const renderOption = (props) => {
  let option = props.data;
  return (
    <div
      onClick={() => props.setValue(props.data)}
      style={{
        fontSize: 16,
        fontWeight: 400,
        color: "#555",
        padding: "15px 20px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "none",
        borderBottom: "1px solid #ededed",
      }}
    >
      <picture>
        <source
          type="image/webp"
          data-srcset={Helper.create_source_set(
            { master: option.master, thumbnails: "1" },
            143,
            "webp"
          )}
          sizes="143px"
        />
        <source
          type="image/png"
          data-srcset={Helper.create_source_set(
            { master: option.master, thumbnails: "1" },
            143
          )}
        />
        <img
          alt=""
          width="65"
          style={{
            marginLeft: -5,
            marginRight: 15,
            transform: option.mirror == "1" ? "scaleX(-1)" : "",
          }}
          className="lazyload"
          data-src={Helper.add_options_img(option.master, 143)}
        />
      </picture>
      <span>
        {option.shoe_name}
        {/*props.favs.filter((x)=>x===option.shoe_id).length!==0 &&
            <i style={{marginLeft:10,color:"orange"}} className="fas fa-star"></i>*/}
      </span>
    </div>
  );
};

const getBorder = (col, row) => {
  if (row === 0 && col !== 0) {
    return {};
  }

  let style = { border: "0.5px solid #ccc" };

  if (col === 0) {
    style = {
      ...style,
      borderLeft: "2px solid var(--primary-color-700)",
      borderRight: "2px solid var(--primary-color-700)",
    };
  }
  if (col === 0 && row === 0) {
    style = {
      ...style,
      borderTop: "2px solid var(--primary-color-700)",
      borderLeft: "2px solid var(--primary-color-700)",
      borderRight: "2px solid var(--primary-color-700)",
    };
  }
  if (col === 0 && row === "last") {
    style = {
      ...style,
      borderBottom: "2px solid var(--primary-color-700)",
      borderLeft: "2px solid var(--primary-color-700)",
      borderRight: "2px solid var(--primary-color-700)",
    };
  }

  return style;
};

export default function SimilarComparison(props) {
  let options = props.overview
    .map((x) => ({ ...x, label: x.shoe_name }))
    .sort((a, b) => (a.shoe_name > b.shoe_name ? 1 : -1));
  const selectRef = useRef();
  const [similarShoes, setSimilarShoes] = useState([
    props.shoe,
    ...(props.shoe.similarShoes ?? [false,false,false,false]),
    false
  ]);
  const [showModal, setShowModal] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [similarIndex, setSimilarIndex] = useState(false);

  useEffect(()=>{
    setSimilarShoes([
      props.shoe,
      ...(props.shoe.similarShoes ?? [false,false,false,false]),
      false
    ]);
  },[props.shoe.similarShoes])

  const displayDiff = (alternative, category) => {
    let shoe = similarShoes[0];
    let diff = Helper.roundto(alternative[category] - shoe[category], 1);
    if (diff == 0) {
      return (
        <span
          style={{
            color: "#38A169",
            fontWeight: 700,
            marginLeft: 10,
            fontSize: 13,
          }}
        >
          (<i style={{ marginRight: 2 }} className="fas fa-arrow-right" />
          {Helper.roundto(Math.abs(diff), 1)})
        </span>
      );
    } else if (diff > 0) {
      return (
        <span
          style={{
            color: diff >= 0 ? "#38A169" : diff >= -0.5 ? "#ED8936" : "#E53E3E",
            fontWeight: 700,
            marginLeft: 10,
            fontSize: 13,
          }}
        >
          (
          {diff >= 0 ? (
            <i style={{ marginRight: 2 }} className="fas fa-arrow-up" />
          ) : (
            <i style={{ marginRight: 2 }} className="fas fa-arrow-down" />
          )}
          {Helper.roundto(Math.abs(diff), 1)})
        </span>
      );
    } else if (diff < 0) {
      return (
        <span
          style={{
            color: diff >= 0 ? "#38A169" : diff >= -0.5 ? "#ED8936" : "#E53E3E",
            fontWeight: 700,
            marginLeft: 10,
            fontSize: 13,
          }}
        >
          (
          {diff >= 0 ? (
            <i style={{ marginRight: 2 }} className="fas fa-arrow-up" />
          ) : (
            <i style={{ marginRight: 2 }} className="fas fa-arrow-down" />
          )}
          {Helper.roundto(Math.abs(diff), 1)})
        </span>
      );
    }
  };

  const removeItem = (index) => {
    let newShoes = [...similarShoes];
    newShoes.splice(index, 1, false);
    newShoes.sort((a, b) => !a - !b);
    setSimilarShoes(newShoes);
  };

  const loadShoe = async(shoe_id)=>{
    let data= await Helper.fetchShoeDataByID(shoe_id);
    let newShoes = [...similarShoes];
    newShoes.splice(similarIndex, 1, data);
    newShoes.sort((a, b) => !a - !b);
    setSimilarShoes(newShoes);
  }



  return (
    <div style={{marginTop:40,marginBottom:40}}>
      <Modal
        onHide={() => {
          setShowModal(false);
        }}
        show={showModal}
      >
        <Modal.Body>
          <Select
            defaultMenuIsOpen={true}
            ref={selectRef}
            instanceId="mobilesearchbox"
            styles={{
              input: (styles) => ({
                ...styles,
                "& input": { transition: "none" },
              }),
              container: (styles) => ({ ...styles, width: "100%" }),
            }}
            components={{ Option: renderOption }}
            onChange={(x) => {
              loadShoe(x.shoe_id);
              setShowModal(false);
            }}
            options={options}
            value={null}
            placeholder="Search Shoe"
          />
        </Modal.Body>
      </Modal>
      <div style={{ overflowX: "auto", marginBottom: 10 }}>
        <table
          css={{
            "& td": { padding: 10 },
            borderCollapse: "collapse",
            marginTop: 30,
            fontSize: 14,
            marginBottom: 10,
            width: 0,
          }}
        >
        <thead>
          <tr>
            <th style={{ minWidth: 120 }}></th>
            {similarShoes.map((shoe, index) => (
              <th
                key={shoe ? shoe.shoe_id : index}
                style={{
                  ...getBorder(index, 0),
                  minWidth: 150,
                  textAlign: shoe ? "left" : "center",
                  verticalAlign: shoe ? "unset" : "middle",
                  paddingRight: 20,
                  position: "relative",
                }}
              >
                {shoe ? (
                  <>
                    <Link onClick={()=> Helper.gaEvent("reviews", "comparison_table_click")} to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}>
                      <picture key={shoe.url}>
                        <source
                          type="image/webp"
                          data-srcset={Helper.create_source_set(
                            shoe.pictures[1],
                            undefined,
                            "webp"
                          )}
                          sizes={"143px"}
                        />
                        <source
                          type="image/png"
                          data-srcset={Helper.create_source_set(
                            shoe.pictures[1],
                            undefined,
                            "png"
                          )}
                          sizes={"143px"}
                        />
                        <img
                          width={shoe.pictures[1].width}
                          height={shoe.pictures[1].height}
                          onClick={() => {}}
                          alt={shoe.shoe_name}
                          css={{
                            objectFit: "contain",
                            objectPosition: "bottom",
                            cursor: "pointer",
                            height: 80,
                            marginTop: 5,
                            marginBottom: 5,
                            transform:
                              shoe.pictures[1].mirror == "1"
                                ? "scaleX(-1)"
                                : "",
                          }}
                          className="lazyload"
                          sizes={"143px"}
                          data-srcset={Helper.create_source_set(
                            shoe.pictures[1]
                          )}
                        />
                      </picture>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "var(--grey-800)",
                          fontSize: 14,
                          lineHeight: 1.4,
                        }}
                      >
                        {shoe.shoe_name}
                      </div>
                    </Link>
                    <span
                      onClick={() => {
                        removeItem(index);
                      }}
                      style={{
                        display: index === 0 ? "none" : "block",
                        cursor: "pointer",
                        fontSize: 16,
                        position: "absolute",
                        top: 10,
                        right: 10,
                      }}
                    >
                      <i style={{color:"var(--grey-600)"}} className="fas fa-times"></i>
                    </span>
                  </>
                ) : (
                  <div
                    onClick={() => {
                      setShowModal(true);
                      setSimilarIndex(index);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="far fa-plus-square" /> Add shoe
                  </div>
                )}
              </th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style={{ border: "0.5px solid #ccc" }}>Expert Rating</td>
            {similarShoes.map((shoe, index) => (
              <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                {shoe && (
                  <>
                    <span
                      style={{
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.rating),
                      }}
                    >
                      {Helper.printRating(shoe.rating)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "rating")}
                  </>
                )}
              </td>
            ))}
          </tr>
          <tr>
            <td style={{ border: "0.5px solid #ccc" }}>User Rating</td>
            {similarShoes.map((shoe, index) => (
              <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                {shoe.user_rating && (
                  <>
                    <span
                      style={{
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.user_rating),
                      }}
                    >
                      {Helper.printRating(shoe.user_rating)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "user_rating")}
                  </>
                )}
              </td>
            ))}
          </tr>
          <tr>
            <td style={{ border: "0.5px solid #ccc" }}>Best Price</td>
            {similarShoes.map((shoe, index) => {
              let discount = Math.round((1 - shoe.discount / shoe.price) * 100);

              return (
                <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                  {shoe && (
                    shoe.new_offer.url ?
                    <a
                      data-tracking-id="comparison_table"
                      {...shoeAffiliateData(shoe)}
                      href={Helper.insert_link(
                        shoe.new_offer.url,
                        "comparison_table",
                        shoe.new_offer.tracking_id
                      )}
                    >
                      <div
                        style={{
                          display: "flex",
                          marginTop: 2,
                          lineHeight: 1.3,
                          flexDirection: "row",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            color: discount > 1 ? "#e32b2b" : "#2d3748",
                          }}
                        >
                          ${shoe.discount}
                        </span>

                        {discount > 1 && (
                          <div
                            style={{
                              color: "#767676",
                              textDecorationLine: "line-through",
                              textDecorationStyle: "solid",
                              marginLeft: 5,
                            }}
                          >
                            ${Math.round(Number(shoe.price))}
                          </div>
                        )}
                      </div>
                    </a>
                    :
                    "$"+shoe.discount
                  )}
                </td>
              );
            })}
          </tr>
          <tr>
            <td style={{ border: "0.5px solid #ccc" }}>Type of Cut</td>
            {similarShoes.map((shoe, index) => (
              <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>{shoe.style ?? ""}</td>
            ))}
          </tr>
          <tr>
            <td style={{ border: "0.5px solid #ccc" }}>Weight</td>
            {similarShoes.map((shoe, index) => (
              <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, showMore ? 1 : "last") }}>
                {shoe &&
                  (shoe.weight_min === "NA"
                    ? "NA"
                    : shoe.weight_min + "g - " + shoe.weight_max + "g")}
              </td>
            ))}
          </tr>
          {showMore && (
            <>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Traction</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    <span
                      style={{
                        fontSize: 14,
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.traction),
                      }}
                    >
                      {Helper.printRating(shoe.traction)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "traction")}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Cushion</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    <span
                      style={{
                        fontSize: 14,
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.cushion),
                      }}
                    >
                      {Helper.printRating(shoe.cushion)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "cushion")}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Materials</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    <span
                      style={{
                        fontSize: 14,
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.materials),
                      }}
                    >
                      {Helper.printRating(shoe.materials)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "materials")}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Support</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    <span
                      style={{
                        fontSize: 14,
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.support),
                      }}
                    >
                      {Helper.printRating(shoe.support)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "support")}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Fit</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    <span
                      style={{
                        fontSize: 14,
                        borderRadius: 2,
                        padding: "3px 8px",
                        color: "white",
                        fontWeight: 600,
                        backgroundColor: Helper.get_color(shoe.support),
                      }}
                    >
                      {Helper.printRating(shoe.fit)}
                    </span>
                    {index !== 0 && displayDiff(shoe, "fit")}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Outdoor</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    {shoe && (
                      <span
                        style={{
                          fontSize: 14,
                          borderRadius: 2,
                          padding: "3px 8px",
                          color: "white",
                          fontWeight: 600,
                          backgroundColor: Helper.get_color(
                            shoe.outdoor,
                            "outdoor"
                          ),
                        }}
                      >
                        {Helper.printRating(shoe.outdoor, 0)}%
                      </span>
                    )}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Width</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, 1) }}>
                    {shoe &&
                      Helper.getSizeDescription(
                        shoe.width,
                        "width",
                        "very_short"
                      )}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ border: "0.5px solid #ccc" }}>Size</td>
                {similarShoes.map((shoe, index) => (
                  <td key={shoe ? shoe.shoe_id : index} style={{ ...getBorder(index, !showMore ? 1 : "last") }}>
                    {shoe &&
                      Helper.getSizeDescription(
                        shoe.size,
                        "size",
                        "very_short"
                      )}
                  </td>
                ))}
              </tr>
            </>
          )}
          </tbody>
        </table>
      </div>
      {!showMore ? (
        <span
          onClick={(x) => setShowMore(true)}
          style={{
            fontSize: 16,
            cursor: "pointer",
            fontWeight: "bold",
            lineHeight: 1.2,
          }}
        >
          <i className="far fa-plus-square"></i>&nbsp;Show More
        </span>
      ) : (
        <span
          onClick={(x) => setShowMore(false)}
          style={{
            fontSize: 16,
            cursor: "pointer",
            fontWeight: "bold",
            lineHeight: 1.2,
          }}
        >
          <i className="far fa-minus-square"></i>&nbsp;Show Less
        </span>
      )}
    </div>
  );
}
